import { toast } from '@/lib/toast';
import { useNotificationStore } from '@/stores/notificationStore';
import i18n from '@/i18n';

/**
 * "This is now running in background" toast + shooting-star-into-the-bell
 * animation, fired whenever a task moves off the user's screen (a new
 * polling task starts, or a processing overlay gets minimized). Shared by
 * BackgroundTaskManager (new task starts) and ProcessingOverlayRoot
 * (overlay minimized) so the two stay in sync.
 */
export function announceBackgroundTaskStarted(
  title: string,
  origin: { x: number; y: number },
): void {
  toast.notification(title || i18n.t('backgroundTask.processing'), {
    description: i18n.t('backgroundTask.runningInBackground'),
    duration: 2000,
    position: 'top-right',
  });
  useNotificationStore.getState().triggerShootingStar(origin);
}
